import CenterModal from './center-modal-container'
export default CenterModal
